module.exports = __webpack_public_path__ + "static/media/border-right.42ad741b.svg";